/**
 *
 */
const recharge = {
  state: {
    currentPayType: {},
    payTypeName: ""
  },
  mutations: {
    SET_RECHARGE_CURPAYTYPE: (state, data) => {
      state.currentPayType = data;
    },
    SET_RECHARGE_PAYTYPENAME: (state, data) => {
      state.payTypeName = data;
    }
  },
  actions: {}
};

export default recharge;
